import {
  LanguagesFormTemplate,
  PreferencesTagButtonsWrapper,
  PrimaryGradientRoundedFluidButton,
  TagButton,
  Text,
} from '@setplex/arcane'
import { useForm } from 'effector-forms'
import { useUnit } from 'effector-react'
import { type FormEvent } from 'react'
import { epgRegionsFeature } from '~/features/epg/regions'
import { GLOBAL_REGION } from '~/shared/constants'
import { $regionsForPopup, epgRegionsForm } from '../model'

RegionsForm.displayName = 'RegionsForm'
export function RegionsForm() {
  const { submit, fields } = useForm(epgRegionsForm)
  const regions = useUnit($regionsForPopup)
  const close = useUnit(epgRegionsFeature.closeRegionsPopup)

  const submitHandler = (e: FormEvent) => {
    e.preventDefault()
    submit()
    close()
  }

  return (
    <LanguagesFormTemplate noValidate={true} onSubmit={submitHandler}>
      <div className='languages-form-content'>
        <Text
          className='text--fonts-subtitle-xl-bold text--color-text-primary form-title'
          text='Watch Live TV from around the world'
        />

        <Text
          className='text--fonts-body-xs-medium text--color-text-secondary form-subtitle'
          text='Choose region — change anytime'
        />

        <PreferencesTagButtonsWrapper>
          {regions?.map(({ id, name = '', alias = GLOBAL_REGION }) => (
            <TagButton
              key={`${id}${name}`}
              title={name}
              isSelected={fields.region.value?.id === id}
              onClick={() => fields.region.set({ id, name, alias })}
            />
          ))}
        </PreferencesTagButtonsWrapper>

        <PrimaryGradientRoundedFluidButton
          className='primary-submit-button'
          type='submit'
          title='Start watching'
        />
      </div>
    </LanguagesFormTemplate>
  )
}
